import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { LoginService } from '../services/login.service';
import { Injectable } from '@angular/core';
import { StorageService } from 'src/app/shared/services/storage.service';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class HttpTokenInjector implements HttpInterceptor {
    constructor(
      private loginService: LoginService,
      private storage: StorageService,
      private router: Router,
    ) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const userToken = this.storage.getItem('token');
        // add authorization header with jwt token if available
        if (userToken && this.loginService.currentUser) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${userToken}`
                }
            });           
        }
        
        return next.handle(request).pipe(
            catchError(error => {
                if (error.status === 401) {
                    this.storage.clear();
                    this.router.navigate(['login']);
                }
                return throwError(error)
            })
        );
    }
}